/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { Search, Button } from "../../component/Component";
import { usePageContext } from "../../../../context/page/PageContext";
import { pushOnePage } from "../../../../middlewares/sysNavigation/SysNavigation";
import {
  FiFolder,
  FiPlusCircle,
  FiSettings,
  FiTag,
  FiCheck,
  FiX,
  FiAlertTriangle,
} from "react-icons/fi";

const addRoute = "/page/add";
const editRoute = "/page/edit";

const Overview = () => {
  const navigate = useNavigate();
  const [categoryList, setCategoryList] = useState([]);
  const { categories, fetchPages, page } = usePageContext();
  const [modal, setModal] = useState({ open: false, action: null, payload: null });

  useEffect(() => {
    if (!categories) fetchPages(1, 1000);
    else setCategoryList(categories);
  }, [categories]);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    if (!categories) return;
    const arr = categories.filter((c) => c.toString().toLowerCase().includes(key));
    setCategoryList(key ? arr : categories);
  };

  const openAdd = () => setModal({ open: true, action: "add", payload: null });
  const openManage = (payload) => setModal({ open: true, action: "manage", payload });
  const closeModal = () => setModal({ open: false, action: null, payload: null });

  const confirm = () => {
    if (modal.action === "add") {
      closeModal();
      navigate(addRoute);
      return;
    }
    if (modal.action === "manage") {
      pushOnePage({ category: modal.payload, localPages: page });
      closeModal();
      navigate(editRoute);
      return;
    }
  };

  return (
    <div className="h-full overflow-y-auto rounded-b-xl bg-gradient-to-b from-white to-gray-50 p-4 lg:p-6">
      <div className="mx-auto max-w-5xl space-y-5">
        <div className="rounded-3xl border border-gray-200 bg-white shadow-sm">
          <div className="flex items-center justify-between gap-3 px-4 py-4 sm:px-6">
            <div className="flex items-center gap-3">
              <span className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white">
                <FiFolder className="h-5 w-5" />
              </span>
              <div>
                <div className="text-sm font-semibold tracking-tight text-gray-900">Page Details</div>
                <div className="mt-0.5 flex flex-wrap items-center gap-2 text-xs">
                  <span className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-gray-700">
                    <FiTag className="h-3.5 w-3.5" />
                    Categories: {categories ? categories.length.toLocaleString() : 0}
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-emerald-700">
                    <FiSettings className="h-3.5 w-3.5" />
                    Manage and edit pages
                  </span>
                </div>
              </div>
            </div>
            <div className="hidden sm:block">
              <Button
                props={{
                  type: "button",
                  title: (
                    <span className="inline-flex items-center gap-2">
                      {/* <FiPlusCircle className="h-4 w-4" /> */}
                      Add New Page
                    </span>
                  ),
                  category: "default",
                  action: "add",
                  onClick: openAdd,
                }}
              />
            </div>
          </div>
          <div className="border-t border-gray-100 px-4 py-4 sm:px-6">
            <Search
              props={{
                title: "Search categories…",
                onChange: (e) => SearchList(e),
              }}
            />
            <div className="mt-4 flex items-center justify-end sm:hidden">
              <Button
                props={{
                  type: "button",
                  title: (
                    <span className="inline-flex items-center gap-2">
                      <FiPlusCircle className="h-4 w-4" />
                      Add New Page
                    </span>
                  ),
                  category: "default",
                  action: "add",
                  onClick: openAdd,
                }}
              />
            </div>
          </div>
        </div>

        <div className="rounded-3xl border border-gray-200 bg-white shadow-sm">
          <div className="relative max-h-[65vh] overflow-auto rounded-3xl">
            <table className="min-w-full table-fixed text-sm">
              <thead className="sticky top-0 z-10 bg-white/90 backdrop-blur">
                <tr className="text-left text-xs uppercase tracking-wide text-gray-500">
                  <th className="w-[70%] px-4 py-3 font-semibold">
                    <span className="inline-flex items-center gap-2">
                      <FiTag className="h-4 w-4" />
                      Category
                    </span>
                  </th>
                  <th className="px-4 py-3 text-center font-semibold">
                    <span className="inline-flex items-center gap-2">
                      <FiSettings className="h-4 w-4" />
                      Action
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {categoryList && categoryList.length > 0 ? (
                  categoryList.map((c, i) => (
                    <tr key={`${c}-${i}`} className="border-t border-gray-100 hover:bg-gray-50/70">
                      <td className="px-4 py-3 align-middle">
                        <div className="flex items-center gap-3">
                          <span className="grid h-8 w-8 place-items-center rounded-lg bg-gray-900 text-[10px] font-bold text-white">
                            {String(c).slice(0, 2).toUpperCase()}
                          </span>
                          <div className="min-w-0">
                            <div className="truncate font-semibold text-gray-900">{c}</div>
                            <div className="mt-0.5 inline-flex items-center gap-1 rounded-md border border-gray-200 bg-gray-100 px-1.5 py-[2px] text-[10px] font-semibold text-gray-700">
                              <FiFolder className="h-3 w-3" />
                              Page category
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3 align-middle">
                        <div className="flex items-center justify-center">
                          <ActionButton category={c} pages={page} onAsk={() => openManage(c)} />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="px-4 py-6 text-center text-gray-500" colSpan={2}>
                      No categories found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <ConfirmModal
        open={modal.open}
        title={modal.action === "add" ? "Create a new page?" : "Open page manager?"}
        description={
          modal.action === "add"
            ? "You are about to start a new page. Continue?"
            : `Manage content in the “${modal.payload ?? ""}” category. Continue?`
        }
        onCancel={closeModal}
        onConfirm={confirm}
      />
    </div>
  );
};

const ActionButton = ({ category, pages, onAsk }) => {
  return (
    <div className="inline-flex items-center gap-3">
      <span className="hidden sm:inline-flex items-center gap-1 rounded-md border border-gray-200 bg-gray-100 px-2 py-[2px] text-[10px] font-semibold text-gray-700">
        <FiTag className="h-3 w-3" />
        {String(category)}
      </span>
      <Button
        props={{
          type: "button",
          title: (
            <span className="inline-flex items-center gap-2">
              <FiSettings className="h-4 w-4" />
              Manage
            </span>
          ),
          category: "blue",
          action: "edit",
          onClick: () => onAsk(),
        }}
      />
    </div>
  );
};

const ConfirmModal = ({ open, title, description, onCancel, onConfirm }) => {
  if (!open) return null;
  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
      aria-describedby="confirm-desc"
      className="fixed inset-0 z-[2147483647] isolate flex items-center justify-center p-4"
    >
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative w-full max-w-md rounded-2xl border border-gray-200 bg-white/95 shadow-2xl ring-1 ring-black/5 supports-[backdrop-filter]:bg-white/85">
        <div className="absolute inset-x-0 top-0 h-1 rounded-t-2xl" />
        <div className="relative px-5 pt-5">
          <div className="flex items-start gap-3">
            <span className="grid h-9 w-9 place-items-center rounded-lg bg-amber-100 text-amber-700">
              <FiAlertTriangle className="h-5 w-5" />
            </span>
            <div>
              <h3 id="confirm-title" className="text-base font-semibold text-gray-900">
                {title}
              </h3>
              {description ? (
                <p id="confirm-desc" className="mt-1 text-sm text-gray-600">
                  {description}
                </p>
              ) : null}
            </div>
          </div>
        </div>
        <div className="px-5 pb-5 pt-4 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
          >
            <FiX className="h-4 w-4" />
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="inline-flex items-center gap-2 rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white shadow hover:bg-black focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
          >
            <FiCheck className="h-4 w-4" />
            Proceed
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Overview;
